import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Button, Checkbox } from 'antd';
import QuestionPopup from '../../../../../../common/components/questionPopup/questionPopup';
import { startSectionContentPopover } from '../contentsForPopover';
import {
  autoSearchByNum,
  autoSearchByNumReset,
} from '../../../../redux/actions/autoSearchActions';
import { clearErrors } from '../../../../redux/actions/vehicleCard';
import moment from 'moment';
/*
const withAvtocod = Component => {
  console.log('Test withAvtocod');
  return props => {
    let handleChange = e => {
      let { value } = e.target;
      value = value.toUpperCase();
      if (value.length && value.length > 6) {
        // todo отправка запроса
        console.log('всё ок', value);
      } else {
        console.log('длинна меньше 7', value, value.length);
      }
    };
    return <Component {...props} handleChange={handleChange} />;
  };
};
*/
// регулярное выражение  подходящее под ГОС номер
// А 007 АА 197
const RegNumExp = [
  // А 007 АА 197
  /^[АВЕКМНОРСТУХ]\d{3}[АВЕКМНОРСТУХ]{2}\d{2,3}$/i,
  // АА 007 77
  /^[АВЕКМНОРСТУХ]{2}\d{5}$/i,
  // АА 0007 77
  /^[АВЕКМНОРСТУХ]{2}\d{6}$/i,
  // 0007 АА 77
  /^\d{4}[АВЕКМНОРСТУХ]{2}\d{2}$/i,
];

const RegisterSign = ({
  form,
  disabled,
  validateField,
  autoSearchByNum,
  autoSearchByNumReset,
  autoSearch,
  typeForm,
  setFormFieldsAvtocod,
  isArchive,
  archievedAt,
  errors,
  clearErrors
}) => {
  const [dataAvtocod, setDataAvtocod] = useState(null);
  const { getFieldDecorator, getFieldValue, getFieldError, isFieldTouched } = form;
  const searchVal = getFieldValue('registerSignAndRegion');
  const isAvtocodSearch = form.getFieldValue('avtocodSearch');
  useEffect(() => {
    return autoSearchByNumReset;
  }, []);

  useEffect(() => {
    if (autoSearch && autoSearch.data !== dataAvtocod) {
      setFormFieldsAvtocod(autoSearch.data);
      setDataAvtocod(autoSearch.data);
    }
  }, [autoSearch]);

  const searchAvtodata = e => {
    const searchVal = getFieldValue('registerSignAndRegion');
    autoSearchByNum(searchVal);
  };
  const handleChange = e => {
    if (autoSearch) {
      autoSearchByNumReset();
    }
  };

  useEffect(() => {
    if (searchVal) {
      clearErrors();
    }
  }, [searchVal])

  let fieldState = {};
  if (!errors && isFieldTouched('registerSignAndRegion')) {
    if (autoSearch && autoSearch.data) {
      fieldState = {
        status: autoSearch.status,
        help: '',
        hasFeedback: true
      }
    } else {
      fieldState = {}
    }
  } else if (errors && errors['vehicle.register_sign'] && !getFieldError('registerSignAndRegion')) {
    fieldState = {
      status: 'error',
      help: 'ТС с таким регистрационным знаком уже добавлено',
      hasFeedback: false
    }
  } else if (isFieldTouched('registerSignAndRegion')) {
    fieldState = {}
  }

  return (
    <Fragment>
      <div className="startSection">
        <div className="aHeight-4"></div>
        {typeForm === 'create' && (
          <div className="checkBoxArea2">
            <div></div>
            <Form.Item>
              {getFieldDecorator('avtocodSearch', {
                valuePropName: 'checked',
              })(
                <Checkbox onChange={autoSearchByNumReset}>
                  Автоматическое определение данных ТС по регистрационному знаку
                </Checkbox>
              )}
              <QuestionPopup
                title="Определение данных ТС"
                width="24px"
                height="24px"
                trigger="click"
                fill="#00a8ff"
              >
                {startSectionContentPopover}
              </QuestionPopup>
            </Form.Item>
          </div>
        )}
        <div className="treeColWrap">
          <span className="label">Регистрационный знак:</span>
          <Form.Item
            validateStatus={fieldState.status}
            help={fieldState.help}
            hasFeedback={fieldState.hasFeedback}
          >
            {getFieldDecorator('registerSignAndRegion', {
              validateFirst: true,
              // validateTrigger: 'onBlur',
              rules: [
                {
                  transform: value => value && value.replace(/\s/g, ''),
                },
                {
                  required: true,
                  message: 'Поле, обязательное для заполнения',
                },
                {
                  validator: (rule, value, callback) => {
                    if (!value.match(/^[0-9А-Я]+$/i)) {
                      callback('Используйте только буквы русского алфавита и цифры');
                    } else {
                      callback();
                    }
                  },
                },
                {
                  message: 'Укажите правильный регистрационный номер',
                  validator: (rule, value, callback) => {
                    if (
                      value && !RegNumExp.some(item => {
                        return value.match(item)
                      })
                    ) {
                      callback('Укажите правильный регистрационный номер');
                    } else {
                      callback();
                    }
                  },
                },
              ],
            })(
              <Input
                placeholder="Укажите регистрационный номер"
                className="longInput"
                disabled={disabled}
                onChange={handleChange}
              />
            )}
          </Form.Item>
          {typeForm === 'create' &&
            isAvtocodSearch &&
            !(autoSearch && autoSearch.status === 'success') && (
              <Button
                type="primary"
                disabled={
                  !(
                    searchVal &&
                    searchVal.length > 6
                  )
                }
                id="defineFederalSignBtn"
                onClick={searchAvtodata}
                loading={autoSearch && autoSearch.isLoading}
              >
                Определить
              </Button>
            )}
          {isArchive ? (
            <span className="label" style={{ color: '#f5222d' }}>В Архиве с: {moment(archievedAt).format('DD.MM.YYYY')}</span>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

export default connect(
  state => ({
    autoSearch: state.Transport.AddVehicle.autoSearch,
    errors: state.Transport.VehicleCard.errors,
  }),
  {
    autoSearchByNum,
    autoSearchByNumReset,
    clearErrors
  }
)(RegisterSign);
